import { notice } from 'JS/utils/notice';

class SpecializationFilter {
    cpecializationFilter;
    filterBtns;
    specializationId;
    vacanciesContainer;

    constructor(elm) {
        this.cpecializationFilter = elm;
        this.filterBtns = this.cpecializationFilter.querySelectorAll('.specialization__filter-btn');
        this.vacanciesContainer = document.querySelector('.vacancies');
        this.init();
    }

    init() {
        this.filterBtns.forEach((elm) => elm.addEventListener('click', this._selectFilter));
    }

    _selectFilter = (e) => {
        const btnFilter = e.target.closest('.specialization__filter-btn');
        const selectedBtnFilter = document.querySelector('.specialization__filter-btn.active');
        
        selectedBtnFilter.classList.remove('active');
        btnFilter.classList.add('active');

        this.specializationId = btnFilter.getAttribute('data-specialization');

        const formData = new FormData();

        formData.append('action', 'get_vacancies');
        formData.append('spec', this.specializationId);

        window.fullscreenLoader.active = true;

        fetch(backendData.ajaxUrl, {
            method: "POST",
            body: formData,
        })
        .then((res) => res.json())
        .then((data) => {
            
            if (data.success) {
                this.vacanciesContainer.innerHTML = data.data.vacancies_html;
            } else {
                notice(data.data?.message, 'warning');
            }
        })
        .catch((error) => {
            notice(error, 'error');
        })
        .finally(() => {
            window.fullscreenLoader.active = false;
        });

        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set("spec", this.specializationId);
        history.replaceState(null, null, "?"+queryParams.toString());
    }

}

export { SpecializationFilter };